module.exports = __webpack_public_path__ + "img/bitab-4.50d3976f.png";